import React, { useEffect, useState } from "react";
import validator from "@rjsf/validator-ajv8";
import { Form } from "@rjsf/mui";
// import schema from "./SampleDetailsSchema.json";
import uischema from "./SampleDetailsUiSchema.json";
import GetAllFiles from "../../Components/GetAllFiles/GetAllFiles";
import LabTestDataTable from "../../Components/dataTable/LabTestDataTable";
import { Button, Box } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../services/StoreHooks";
import useSampleDetailsSchema from "./useSampleDetailsSchema";

function SampleDetails({
  testDone,
  isMonitor,
  sampleData,
  setData,
  setSampleTestData,
  addPath,
  createFileUploadFields,
  getFileData,
  handleFileDelete,
  setShowButton,
  showButton,
  setRemovedNames,
  currentCategoryId,
  fileUploadData,
  sourceCategoryData,
  sampleTableData,
  inputData,
  sampleId
}) {
 
  const schema = useSampleDetailsSchema();
  const [formData, setFormData] = useState(inputData);
  const [fileUploadValidated, setFileUploadValidated] = useState(false);
  const [tableDataValidated, setTableDataValidated] = useState(false);
  const dispatch = useAppDispatch();

  const date = sampleData?.testDate?.slice(0, 10);
  const performedBy = sampleData?.performedBy;

  useEffect(() => {
    setFormData({ testDate: date || inputData.testDate, performedBy: performedBy });
  }, [sampleData]);

  const UpdatedUiSchema = {};
  UpdatedUiSchema["LabTest"] = {
    "ui:widget": "TestDetailsWidget",
  };
  UpdatedUiSchema["GetAllFiles"] = {
    "ui:widget": "GetAllFilesWidget",
  };
  UpdatedUiSchema["testDate"] = {
    "ui:disabled": true,
  };
  UpdatedUiSchema["performedBy"] = {
    "ui:disabled": true,
  };

  const dispatchNotification = (typ, msg) => {
    dispatch({
      type: "SHOW_NOTIFICATION",
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const TestDetailsWidget = () => {
    return (
      sampleData?.labTests && 
      <LabTestDataTable
        sampleId={sampleId}
        testDone={testDone}
        isMonitor={isMonitor}
        setSampleTableData={setSampleTestData}
        prepopulatedData={sampleData?.labTests}
        currentCategoryId={currentCategoryId}
        setShowButton={setShowButton}
      />
    );
  };
  const GetAllFilesWidget = () => {
    return (
      <GetAllFiles
      sampleId={sampleId}
        addPath={addPath}
        testDone={testDone}
        isMonitor={isMonitor}
        createFileUploadFields={createFileUploadFields}
        getFileData={getFileData}
        handleFileDelete={handleFileDelete}
        setRemovedNames={setRemovedNames}
        setShowButton={setShowButton}
      />
    );
  };


  const widgets = { TestDetailsWidget, GetAllFilesWidget };
  return (
    <Box id="BatchDetails" className="form-div ">
      <Box p={2} id="rjsf">
        <div id="batch-detail-form">
          <Form
            className="lab-test-details"
            schema={schema}
            validator={validator}
            uiSchema={(testDone || isMonitor) ? UpdatedUiSchema : uischema}
            widgets={widgets}
            formData={formData}
            onChange={(e) => {
              setFormData(e.formData);
              setShowButton(true);
              setData(e.formData);
            }}
            children={true}
          ></Form>
        </div>
      </Box>
    </Box>
  );
}

export default SampleDetails;
